/**
 *    @tableOfContent
 *      1. Dependencies
 *      2. Class
 *      3. Export class
 *
 */

/**
 *     @section 1. Dependencies
 */
import Helper from '../app/app--helper'

/**
 *     @section 2. Class
 */
class MapToggle {
    constructor() {
        const containerEl =  document.querySelector('.region-with-map')

        if (containerEl) {
            this.init(containerEl)
        }
    }

    private init(containerEl): void {
        const showMapSwitchEl = containerEl?.querySelector('[name="show-map"]') as HTMLInputElement
        const breakpoint = Helper.getCurrentBreakpoint()


        // on init and not mobile
        if (localStorage.getItem('showMap') && breakpoint !== 'xs' && breakpoint !== 'sm' && breakpoint !== 'md') {
            showMapSwitchEl.checked = true
        }

        // on init
        if (showMapSwitchEl?.checked) {
            containerEl?.classList.add('map-open')
        }

        // on change
        showMapSwitchEl?.addEventListener('change', () => {
            this.saveToggleState(containerEl, showMapSwitchEl?.checked)
        })

        // mobile
        document.querySelectorAll('[data-map-close]').forEach((buttonEl) => {
            buttonEl.addEventListener('click', () => {
                // console.log('close map')
                showMapSwitchEl.checked = false

                // Create a new 'change' event
                let event = new Event('change')
                showMapSwitchEl.dispatchEvent(event)
            })
        })
    }

    private saveToggleState(containerEl, state: boolean): void {
        containerEl?.classList.toggle('map-open')

        if (state) {
            localStorage.setItem('showMap', 'true')
        } else {
            localStorage.removeItem('showMap')
        }
    }
}

/**
 *     @section 3. Export class
 */

export default new MapToggle()

// end of map-toggle.ts file
